import React, { useState, useEffect } from 'react';
import { QRCodeSVG as QRCode } from 'qrcode.react';


const API_BASE = process.env.REACT_APP_API_BASE || '';



const COUNTRIES = [
  { name: 'India', code: '+91', flag: '🇮🇳' },
  { name: 'United States', code: '+1', flag: '🇺🇸' },
  { name: 'United Kingdom', code: '+44', flag: '🇬🇧' },
  { name: 'Canada', code: '+1', flag: '🇨🇦' },
  { name: 'Australia', code: '+61', flag: '🇦🇺' },
  { name: 'Germany', code: '+49', flag: '🇩🇪' },
  { name: 'France', code: '+33', flag: '🇫🇷' },
  { name: 'Italy', code: '+39', flag: '🇮🇹' },
  { name: 'Spain', code: '+34', flag: '🇪🇸' },
  { name: 'Netherlands', code: '+31', flag: '🇳🇱' },
  { name: 'Belgium', code: '+32', flag: '🇧🇪' },
  { name: 'Switzerland', code: '+41', flag: '🇨🇭' },
  { name: 'Austria', code: '+43', flag: '🇦🇹' },
  { name: 'Sweden', code: '+46', flag: '🇸🇪' },
  { name: 'Norway', code: '+47', flag: '🇳🇴' },
  { name: 'Denmark', code: '+45', flag: '🇩🇰' },
  { name: 'Finland', code: '+358', flag: '🇫🇮' },
  { name: 'Ireland', code: '+353', flag: '🇮🇪' },
  { name: 'Portugal', code: '+351', flag: '🇵🇹' },
  { name: 'Poland', code: '+48', flag: '🇵🇱' },
  { name: 'Russia', code: '+7', flag: '🇷🇺' },
  { name: 'China', code: '+86', flag: '🇨🇳' },
  { name: 'Japan', code: '+81', flag: '🇯🇵' },
  { name: 'South Korea', code: '+82', flag: '🇰🇷' },
  { name: 'Singapore', code: '+65', flag: '🇸🇬' },
  { name: 'Malaysia', code: '+60', flag: '🇲🇾' },
  { name: 'Indonesia', code: '+62', flag: '🇮🇩' },
  { name: 'Thailand', code: '+66', flag: '🇹🇭' },
  { name: 'Vietnam', code: '+84', flag: '🇻🇳' },
  { name: 'Philippines', code: '+63', flag: '🇵🇭' },
  { name: 'Pakistan', code: '+92', flag: '🇵🇰' },
  { name: 'Bangladesh', code: '+880', flag: '🇧🇩' },
  { name: 'Sri Lanka', code: '+94', flag: '🇱🇰' },
  { name: 'Nepal', code: '+977', flag: '🇳🇵' },
  { name: 'UAE', code: '+971', flag: '🇦🇪' },
  { name: 'Saudi Arabia', code: '+966', flag: '🇸🇦' },
  { name: 'Qatar', code: '+974', flag: '🇶🇦' },
  { name: 'Kuwait', code: '+965', flag: '🇰🇼' },
  { name: 'Bahrain', code: '+973', flag: '🇧🇭' },
  { name: 'Oman', code: '+968', flag: '🇴🇲' },
  { name: 'Israel', code: '+972', flag: '🇮🇱' },
  { name: 'Turkey', code: '+90', flag: '🇹🇷' },
  { name: 'South Africa', code: '+27', flag: '🇿🇦' },
  { name: 'Nigeria', code: '+234', flag: '🇳🇬' },
  { name: 'Egypt', code: '+20', flag: '🇪🇬' },
  { name: 'Kenya', code: '+254', flag: '🇰🇪' },
  { name: 'Brazil', code: '+55', flag: '🇧🇷' },
  { name: 'Mexico', code: '+52', flag: '🇲🇽' },
  { name: 'Argentina', code: '+54', flag: '🇦🇷' },
  { name: 'Colombia', code: '+57', flag: '🇨🇴' },
  { name: 'Chile', code: '+56', flag: '🇨🇱' },
  { name: 'Peru', code: '+51', flag: '🇵🇪' },
  { name: 'New Zealand', code: '+64', flag: '🇳🇿' }
].sort((a, b) => a.name.localeCompare(b.name));

function App() {
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [user, setUser] = useState(null);
  const [view, setView] = useState(token ? 'loading' : 'login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [config, setConfig] = useState('');
  const [selectedServer, setSelectedServer] = useState('');
  const [deviceName, setDeviceName] = useState('');
  const [loading, setLoading] = useState(false);
  const [resetToken, setResetToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [resetMsg, setResetMsg] = useState('');

  const serverOptions = {
    blr1: { label: '🌏 Bangalore, India' },
    tor1: { label: '🍁 Toronto, Canada' },
    nyc3: { label: '🗽 New York, USA' },
    sfo3: { label: '🌉 San Francisco, USA' },
    lon1: { label: '🇬🇧 London, UK' },
    fra1: { label: '🇩🇪 Frankfurt, Germany' },
    syd1: { label: '🇦🇺 Sydney, Australia' }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const rt = params.get('token');
    if (window.location.pathname === '/reset-password' && rt) {
      setResetToken(rt);
      setView('reset-password');
      return;
    }
    if (token) fetchStatus();
  }, [token]);


  const fetchStatus = async () => {

    try {
      const res = await fetch(`${API_BASE}/api/status`, { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) throw new Error();
      const data = await res.json();
      setUser(data.data);
      setView(data.data.valid ? 'dashboard' : 'expired');
    } catch { logout(); }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await fetch(`${API_BASE}/api/login`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      localStorage.setItem('token', data.data.token);
      setToken(data.data.token);
      setView('loading');
    } catch (err) { setError(err.message); }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(''); setUser(null); setView('login'); setConfig('');
  };

  const handleGenerate = async () => {
    if (!selectedServer) { alert('Select a server'); return; }
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/generate-config`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ server: selectedServer, deviceName: deviceName || `Device ${(user?.devices?.length || 0) + 1}` })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      setConfig(data.data.config);
      setDeviceName('');
      fetchStatus();
    } catch (err) { alert(err.message); }
    finally { setLoading(false); }
  };

  const deleteDevice = async (id) => {
    if (!window.confirm('Delete this device?')) return;
    await fetch(`${API_BASE}/api/device/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
    fetchStatus();
    setConfig('');
  };

  const downloadConfig = () => {
    const blob = new Blob([config], { type: 'text/plain' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'SkyboundVPN.conf';
    link.click();
  };

  const downloadQRCode = () => {
    const svg = document.querySelector('#qrcode-container svg');
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.onload = () => {
      canvas.width = img.width; canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const link = document.createElement('a');
      link.href = canvas.toDataURL('image/png');
      link.download = 'SkyboundVPN-QR.png';
      link.click();
    };
    img.src = URL.createObjectURL(new Blob([svgData], { type: 'image/svg+xml' }));
  };




  if (view === 'login') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 text-white flex items-center justify-center px-4">
        <div className="w-full max-w-md bg-gray-950 rounded-lg p-6 border border-gray-700">
          <div className="text-center mb-6">
            <img src="/logo.png" alt="Logo" className="h-16 mx-auto mb-4" />
            <h1 className="text-3xl font-bold"><span className="text-red-600">Skybound</span>Cyber</h1>
            <p className="text-gray-400 text-sm mt-1">Secure VPN Access</p>
          </div>
          {error && <div className="bg-red-600/20 border border-red-600 text-red-400 px-4 py-2 rounded mb-4 text-sm">{error}</div>}
          
            <form onSubmit={handleLogin}>
              <div className="mb-4">
                <label className="block text-sm text-gray-400 mb-1">Email</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full bg-gray-800 border border-gray-600 px-4 py-2 rounded focus:border-blue-500 focus:outline-none" required />
              </div>
              <div className="mb-4">
                <label className="block text-sm text-gray-400 mb-1">Password</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full bg-gray-800 border border-gray-600 px-4 py-2 rounded focus:border-blue-500 focus:outline-none" required />
              </div>
              <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 py-2 rounded font-semibold mb-4">Login</button>
            </form>
          
          <p className="text-center text-gray-400 text-sm mt-4">
            Account registration via webhooks only
          </p>
        </div>
      </div>
    );
  }


  if (view === 'reset-password') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 text-white flex items-center justify-center px-4">
        <div className="w-full max-w-md bg-gray-950 rounded-lg p-6 border border-gray-700">
          <div className="text-center mb-6">
            <img src="/logo.png" alt="Logo" className="h-16 mx-auto mb-4" />
            <h1 className="text-3xl font-bold"><span className="text-red-600">Skybound</span>Cyber</h1>
            <p className="text-gray-400 text-sm mt-1">Reset Your Password</p>
          </div>
          {resetMsg && <div className={`px-4 py-2 rounded mb-4 text-sm ${resetMsg.includes('success') ? 'bg-green-600/20 border border-green-600 text-green-400' : 'bg-red-600/20 border border-red-600 text-red-400'}`}>{resetMsg}</div>}
          <form onSubmit={async (e) => {
            e.preventDefault();
            try {
              const res = await fetch(`${API_BASE}/api/reset-password`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token: resetToken, password: newPassword })
              });
              const data = await res.json();
              if (!res.ok) throw new Error(data.message);
              setResetMsg('Password reset successfully. Return to the app to login.');
              localStorage.removeItem('token');
            } catch (err) { setResetMsg(err.message); }
          }}>
            <div className="mb-4">
              <label className="block text-sm text-gray-400 mb-1">New Password</label>
              <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} className="w-full bg-gray-800 border
  border-gray-600 px-4 py-2 rounded focus:border-blue-500 focus:outline-none" required minLength={8} />
            </div>
            <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 py-2 rounded font-semibold">Reset Password</button>
          </form>
        </div>
      </div>
    );
  }

  if (view === 'loading') return <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">Loading...</div>;

  if (view === 'expired') {
    return (
      <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-red-500 mb-4">Subscription Expired</h1>
          <a href="https://skyboundcyber.com/pricing" className="bg-green-600 px-6 py-2 rounded inline-block mb-4">Subscribe Now</a>
          <br /><button onClick={logout} className="text-gray-400">Logout</button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 text-white px-4 py-8">
      <div className="max-w-3xl mx-auto bg-gray-950 rounded-lg p-6 border border-gray-700">
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="Logo" className="h-12" />
            <h1 className="text-2xl font-bold"><span className="text-red-600">Skybound</span>Cyber</h1>
          </div>
          <button onClick={logout} className="text-gray-400 hover:text-white text-sm">Logout</button>
        </div>

        <div className="bg-gray-800 rounded p-4 mb-6 flex justify-between items-center">
          <div>
            <p className="text-sm text-gray-400">{user?.email}</p>
            <p className="text-lg font-semibold">
              {user?.status === 'trial' && <span className="text-yellow-400">🕐 Trial - {user?.daysLeft} days left</span>}
              {user?.status === 'active' && <span className="text-green-400">✓ Active</span>}
            </p>
          </div>
          <div className="text-right">
            <p className="text-sm text-gray-400">Devices</p>
            <p className="text-lg font-semibold">{user?.devices?.length || 0} / {user?.deviceLimit}</p>
          </div>
        </div>

        {user?.devices?.length > 0 && (
          <div className="mb-6">
            <h2 className="text-lg font-semibold mb-3">Your Devices</h2>
            {user.devices.map(device => (
              <div key={device.id} className="bg-gray-800 rounded p-3 mb-2 flex justify-between items-center">
                <div>
                  <p className="font-medium">{device.name}</p>
                  <p className="text-sm text-gray-400">Server: {device.server} • IP: {device.assigned_ip}</p>
                </div>
                <button onClick={() => deleteDevice(device.id)} className="text-red-400 text-sm">Delete</button>
              </div>
            ))}
          </div>
        )}

        {(user?.devices?.length || 0) < user?.deviceLimit && (
          <>
            <div className="mb-4">
              <label className="block text-sm text-gray-400 mb-1">Select VPN Server</label>
              <select value={selectedServer} onChange={e => setSelectedServer(e.target.value)} className="w-full bg-gray-800 border border-gray-600 px-4 py-2 rounded">
                <option value="">Choose server...</option>
                {Object.entries(serverOptions).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
              </select>
            </div>
            <div className="mb-4">
              <label className="block text-sm text-gray-400 mb-1">Device Name (optional)</label>
              <input type="text" placeholder="e.g. My Phone" value={deviceName} onChange={e => setDeviceName(e.target.value)} className="w-full bg-gray-800 border border-gray-600 px-4 py-2 rounded" />
            </div>
            <button onClick={handleGenerate} disabled={loading} className="w-full bg-blue-600 hover:bg-blue-700 py-2 rounded font-semibold mb-6">
              {loading ? '⏳ Connecting...' : '🎯 Generate Config'}
            </button>
          </>
        )}

        {(user?.devices?.length || 0) >= user?.deviceLimit && !config && (
          <div className="bg-yellow-600/20 border border-yellow-600 text-yellow-400 px-4 py-3 rounded mb-6">Device limit reached. Delete a device to add new one.</div>
        )}

        {config && (
          <div className="space-y-4">
            <div className="bg-green-600/20 border border-green-600 text-green-400 px-4 py-3 rounded">✅ VPN configured!</div>
            <pre className="bg-gray-800 p-4 rounded text-sm text-green-200 overflow-x-auto">{config}</pre>
            <div id="qrcode-container" className="flex justify-center py-4">
              <QRCode value={config} size={200} fgColor="#000" bgColor="#fff" includeMargin />
            </div>
            <div className="flex gap-4 justify-center">
              <button onClick={downloadQRCode} className="bg-purple-600 hover:bg-purple-700 px-4 py-2 rounded">⬇️ QR Code</button>
              <button onClick={downloadConfig} className="bg-green-600 hover:bg-green-700 px-4 py-2 rounded">📄 Config File</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
